import { gsap, ScrollTrigger } from './rk-gsap-core';

/**
 * "Register" button (.register-link > a) logic:
 * - If body does not include class "page-home", add 'open' class to section.register-panel
 */

const initializeMobileNav = () => {
  const navbar = document.querySelector('.navbar-outer')
  const navbarToggleButton = navbar.querySelector('.navbar-toggler')
  const registerLink = navbar.querySelector('.register-link > a')

  navbarToggleButton.addEventListener('click', () => {
    navbar.classList.toggle('open')
  })

  if (document.body.classList.contains('page-home') && registerLink) {
    registerLink.addEventListener('click', () => {
      navbar.classList.remove('open')
    })
  }
}

const initializeRegisterLink = () => {
  const navbar = document.querySelector('.navbar-outer')
  const registerLink = navbar.querySelector('.register-link > a')
  const registerCloseButton = document.querySelector('.register-panel .register-panel-close')

  if (registerCloseButton) {
    registerCloseButton.addEventListener('click', () => {
      const registerPanel = document.querySelector('.register-panel')
      if (registerPanel) {
        registerPanel.classList.remove('open')
      }
    })
  }

  registerLink.addEventListener('click', (e) => {
    e.preventDefault()
    const registerPanel = document.querySelector('.register-panel')
    if (registerPanel) {
      registerPanel.classList.toggle('open')
    }
  })
}

const initializeNavbarSolidOnScroll = () => {
  const navbar = document.querySelector('.navbar-outer')

  if (!navbar) {
    return
  }

  const updateNavbarState = () => {
    if (window.scrollY >= 100) {
      navbar.classList.add('navbar-solid')
      return
    }

    navbar.classList.remove('navbar-solid')
  }

  updateNavbarState()
  window.addEventListener('scroll', updateNavbarState, { passive: true })
}

export const initializeNavbar = () => {
  initializeMobileNav()

  if ( !document.body.classList.contains('page-homes') ) {
    initializeNavbarSolidOnScroll()
  }

  if (!document.body.classList.contains('page-home')) {
    initializeRegisterLink()
  }
}